
import "./scripts.js";
import { typeWriter } from "./typing-effect.js";
import "./animations.js";

async function loadLiveStatsAndCount() {
  let live = null;
  try {
    const res = await fetch("/api/public/platform-stats", { method: "GET" });
    if (res.ok) live = await res.json();
  } catch {
    live = null;
  }

  if (live) {
    const map = [
      ["stat-hq", "global_hq", 1],
      ["stat-orgs", "total_organizations", 0],
      ["stat-uptime", "uptime_percent", 99.9],
      ["stat-support", "support_hours", 24],
      ["stat-modules", "core_modules", 8],
      ["stat-founded", "year_founded", 2025],
    ];
    for (const [id, key, fallback] of map) {
      const el = document.getElementById(id);
      if (!el) continue;
      const value = live && typeof live[key] === "number" ? live[key] : fallback;
      el.setAttribute("data-count", String(value));
    }
  }

  startCountAnimations();
}

function startCountAnimations() {
  const statNumbers = document.querySelectorAll(".stat-number[data-count]");
  const duration = 1600;
  const startTs = performance.now();

  function tick(now) {
    const progress = Math.min(1, (now - startTs) / duration);
    const eased = 1 - Math.pow(1 - progress, 3);
    statNumbers.forEach((el) => {
      const target = parseFloat(el.getAttribute("data-count") || "0");
      if (!Number.isFinite(target)) return;
      const current = target * eased;
      const display = Number.isInteger(target)
        ? Math.floor(current).toLocaleString("en-US")
        : current.toFixed(target % 1 === 0 ? 0 : 1);
      el.textContent = display;
    });
    if (progress < 1) requestAnimationFrame(tick);
  }

  requestAnimationFrame(tick);
}

document.addEventListener("DOMContentLoaded", () => {
  const typingHeading = document.getElementById("typing-heading");
  if (typingHeading) {
    typingHeading.textContent = "";
    typeWriter(typingHeading, "Redefining Management");
  }

  loadLiveStatsAndCount();
});
